<template>
  <div
    v-if="shouldShow"
  >
    <v-row
      align="center"
      no-gutters
      class="my-5"
    >
      <v-divider />
      <v-btn
        class="mx-4 text-caption text-uppercase"
        small
        color="secondary"
        @click="dialog = true"
      >
        <v-icon class="mr-2">
          add
        </v-icon>
        Add Relative Party's {{ title }}
      </v-btn>
      <v-divider />
    </v-row>
    <PEPartyRelativeSectionDialog
      v-model="dialog"
      :title="title"
      :property="property"
      :on-select="onAdd"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import PEPartyRelativeSectionDialog from './PEPartyRelativeSectionDialog.vue'

export default {
  name: 'RelativeSectionAdderLine',

  components: {
    PEPartyRelativeSectionDialog,
  },

  props: {
    property: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      dialog: false,
    }
  },

  computed: {
    shouldShow () {
      return (
        !this.peGenericSectionLoading &&
        this.peUserCanUpdate === true
      )
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peGenericSectionLoading',
      'peUserCanUpdate',
    ]),
  },

  methods: {
    onAdd (data) {
      this.$emit('on-add', data)
    },
  },
}
</script>
